var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeteransGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.9,24.2L38.9,24.2c-0.5,0-0.9,0.4-0.9,0.9v8c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.4,0.3,0.6,0.3l0,0 c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.3-0.4,0.3-0.6v-8C39.7,24.6,39.3,24.2,38.9,24.2z M38.8,24.3L38.8,24.3L38.8,24.3L38.8,24.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "44.2,47.4 42.5,41.8 40.8,47.4 34.9,47.4 39.5,51 37.8,56.2 42.5,53.3 47.2,56.2 45.5,51 50.1,47.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.5,38.2l2.2-3.5l0,0c0.4-0.7,0.6-1.5,0.6-2.3v-9.5c0-1.3-1-2.3-2.3-2.3H33.1c-1.3,0-2.3,1-2.3,2.3v9.5 c0,0.8,0.2,1.6,0.6,2.3l0.1,0.1l2.6,3.1c-3.7,2.7-6.1,7-6.1,11.9c0,8.1,6.6,14.7,14.7,14.7s14.7-6.6,14.7-14.7 C57.2,45.1,54.9,40.9,51.5,38.2z M42.5,62.8c-7.2,0-13-5.8-13-13s5.8-13,13-13s13,5.8,13,13S49.7,62.8,42.5,62.8z M42.5,35.1 c-2.6,0-5,0.7-7.1,1.8l-2.6-3.1c-0.2-0.5-0.4-1-0.4-1.5v-9.5c0-0.3,0.3-0.6,0.6-0.6h19c0.3,0,0.6,0.3,0.6,0.6v9.5 c0,0.5-0.1,1.1-0.4,1.6L50,37.2C47.8,35.9,45.3,35.1,42.5,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.1,24.2L46.1,24.2c-0.5,0-0.9,0.4-0.9,0.9v8c0,0.5,0.4,0.9,0.8,0.9l0,0c0.2,0,0.4-0.1,0.6-0.2 c0.2-0.2,0.3-0.4,0.3-0.6v-8C47,24.6,46.6,24.2,46.1,24.2z M46.1,24.3L46.1,24.3L46.1,24.3L46.1,24.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeteransGrey);
export default __webpack_public_path__ + "static/media/VeteransGrey.a740db8ffc732d9eed4450f0b6c166bb.svg";
export { ForwardRef as ReactComponent };